import { ReactNode } from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface PageContainerProps {
  children?: ReactNode;
  className?: string;
  /** Zeigt Loading-State anstelle des Inhalts */
  isLoading?: boolean;
  /** Custom Skeleton statt Standard-Spinner */
  skeleton?: ReactNode;
  /** Minimale Höhe im Loading-State (default: min-h-[400px]) */
  loadingMinHeight?: string;
  /** Test-ID für E2E-Tests */
  "data-testid"?: string;
}

export function PageContainer({
  children,
  className,
  isLoading = false,
  skeleton,
  loadingMinHeight = "min-h-[400px]",
  "data-testid": testId,
}: PageContainerProps) {
  // Wenn Skeleton vorhanden, zeige diesen im Padding-Container
  if (isLoading && skeleton) {
    return (
      <div className={cn("p-6 @lg:p-8 container-responsive", className)} data-testid={testId}>
        {skeleton}
      </div>
    );
  }

  // Standard Loading-Spinner
  if (isLoading) {
    return (
      <div
        className={cn(
          "p-6 @lg:p-8 container-responsive flex items-center justify-center",
          loadingMinHeight,
          className,
        )}
        data-testid={testId}
      >
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <div
      className={cn("p-6 @lg:p-8 overflow-x-hidden container-responsive", className)}
      data-testid={testId}
    >
      {children}
    </div>
  );
}
